module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/141x2Xh/tc-custom/9783988268594.jpg?1704453172089",
      "alt": "This image is the cover for the book Murder in the Maze, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murder in the Maze, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Murder in the Maze is a mystery novel written by J. J. Connington, the pseudonym of Alfred Walter Stewart, a notable British author of detective fiction during the Golden Age of detective fiction. The novel is known for its intricate plotting and classic mystery elements.  The story begins with the murder of Sir Richard March, a wealthy and influential man. The setting, March's elaborate and confusing hedge maze, plays a crucial role in the unfolding events. The maze is not just a picturesque garden feature; it becomes the scene of the crime. Sir Richard March is found murdered within its twists and turns. Inspector James, a methodical and sharp-witted detective, is called in to investigate the baffling murder.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      J. J. Connington\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Henry Herbert Knibbs (January 24, 1874 – February 10, 1945) was an American poet, journalist, and author known for his Western poetry and cowboy-themed works. He gained popularity during the early 20th century for his ability to capture the essence of the American West in his poetry and storytelling.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0